module.exports = __webpack_public_path__ + "gt.003be3141c29dd3b7fb6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gt.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gt.svg
// module chunks = styles